import ModuleWrapper from 'shared-lib/containers/Module';
import store from '@/store';

const Users = () => import(/* webpackChunkName: "users" */ '@/views/users/Users');
const UserForm = () => import(/* webpackChunkName: "user-form" */ '@/views/users/UserForm');
const UserDetails = () => import(/* webpackChunkName: "user-details" */ '@/views/users/UserDetails');
const meta = (data = {}) => ({
    privilegeModule: 'users',
    title: 'Users',
    auth: true,
    ...data,
});

export default [{
    path: 'dashboard/users',
    component: ModuleWrapper,
    meta: meta({
        permission: 'list',
    }),
    children: [
        {
            path: '',
            name: 'Users',
            component: Users,
            meta: meta({
                permission: 'list',
            }),
        },
        {
            path: 'add',
            name: 'addUser',
            component: UserForm,
            meta: meta({
                permission: 'create',
            }),
        },
        {
            path: ':id(\\d+)',
            name: 'showUser',
            component: UserDetails,
            props: true,
            meta: meta({
                permission: 'read',
            }),
        },
        {
            path: ':id(\\d+)/edit',
            name: 'editUser',
            component: UserForm,
            props: true,
            beforeEnter: (to, from, next) => {
                store.dispatch('initAuth')
                    .then(() => {
                        const callback = () => store.state.currentUser.id === parseInt(to.params.id) ? next('/users') : next();
                        if (store.state.currentUser.id) {
                            return callback();
                        }

                        store.dispatch('getCurrentUser').then(() => {
                            return callback();
                        });
                    });
            },

            meta: meta({
                permission: 'update',
            }),
        },
    ],
}];
